import { createStore } from 'vuex'
import auth from './modules/auth'
import articles from './modules/articles'
import ui from './modules/ui'

export default createStore({
  state: {
    loading: false,
    error: null
  },
  getters: {
    loading: state => state.loading,
    error: state => state.error
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    setError({ commit }, error) {
      commit('SET_ERROR', error)
    }
  },
  modules: {
    auth,
    articles,
    ui
  }
})